var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7333 0.691609C15.8116 0.612728 15.9181 0.568359 16.0292 0.568359C16.1403 0.568359 16.2468 0.612728 16.325 0.691609L17.2083 1.57494C17.2889 1.65055 17.3346 1.75612 17.3346 1.86661C17.3346 1.9771 17.2889 2.08266 17.2083 2.15828L9.55 9.81661C9.43291 9.93385 9.27404 9.9998 9.10834 9.99994H8.89167C8.72597 9.9998 8.5671 9.93385 8.45 9.81661L0.791671 2.15828C0.711106 2.08266 0.665405 1.9771 0.665405 1.86661C0.665405 1.75612 0.711106 1.65055 0.791671 1.57494L1.675 0.691609C1.75324 0.612728 1.85974 0.568359 1.97084 0.568359C2.08194 0.568359 2.18843 0.612728 2.26667 0.691609L9 7.42494L15.7333 0.691609Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/Arrow_Down.ab64553906d652c36660f572e7e4cdc5.svg";
export { ForwardRef as ReactComponent };